/**
 * Pick the chosen file off a file input, tolerating browsers/extensions that
 * fill `files` late or only fire `input` instead of `change`.
 *
 * Some managed-device upload controls (DLP / upload gateways) intercept the
 * native picker and populate the input after the change event has already
 * fired, so reading `files` once and immediately clearing the input drops the
 * file. This waits briefly for it to appear.
 */
export async function readPickedFile(input: HTMLInputElement, waitMs = 1500): Promise<File | null> {
  const deadline = Date.now() + waitMs;
  for (;;) {
    const file = input.files?.[0];
    if (file) return file;
    if (Date.now() >= deadline) return null;
    await new Promise((r) => window.setTimeout(r, 100));
  }
}
